import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
// import LoginForm from "../components/LoginForm";
import RegisterForm from "../components/RegisterForm";

const AuthPage = () => {
  return (
    <>
      <Header />
      <RegisterForm />
      <Footer />
    </>
  );
};

export default AuthPage;
